import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired with the Creator Marketplace (LUT-982); old links land on Albums.
export const Route = createFileRoute("/marketplace/_layout/beats")({
  beforeLoad: () => {
    throw redirect({ to: "/marketplace/albums", replace: true });
  },
});
